import { DevelopmentTool } from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import { VISIBILITY_THRESHOLDS } from '../constants/intersectionObserver';

export const findMostVisibleSection = (
  entries: IntersectionObserverEntry[],
): IntersectionObserverEntry | null => {
  const visibleEntries = entries.filter((entry) => entry.isIntersecting);
  if (visibleEntries.length === 0) {
    return null;
  }

  let mostVisibleEntry = visibleEntries[0];
  visibleEntries.forEach((entry) => {
    if (entry.intersectionRatio > mostVisibleEntry.intersectionRatio) {
      mostVisibleEntry = entry;
    }
  });
  return mostVisibleEntry;
};

export const findTabIdForSection = (
  sectionElement: Element,
  sectionRefs: Record<DevelopmentTool, React.RefObject<HTMLDivElement>>,
  templateTabs: DevelopmentTool[],
): DevelopmentTool | undefined => {
  return templateTabs.find((tabId) => {
    if (tabId === DevelopmentTool.UNKNOWN_TEMPLATE_TYPE) {
      return false;
    }
    return sectionRefs[tabId]?.current === sectionElement;
  });
};

export const getMinThresholdForTab = (
  tabId: DevelopmentTool | undefined,
): number => {
  if (tabId === DevelopmentTool.UNKNOWN_TEMPLATE_TYPE || !tabId) {
    return 0.2;
  }

  return VISIBILITY_THRESHOLDS[tabId] ?? 0.2;
};
